document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
        autoplay: {
            delay: 8000,
            disableOnInteraction: false
        },
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {
        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    if(document.querySelectorAll('.swiper-slider-v2')) {
        const sliders = document.querySelectorAll('.swiper-slider-v2');
        sliders.forEach( (slider, index) => {
            console.log(`.${slider.getAttribute('class')}`);
            
            let swiper = new Swiper( `.${slider.getAttribute('class')}`, {
                oop: true,
                speed: 700,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
            })
        });
    }
    
    if( document.querySelectorAll('.team-quad__slider') ){

        const teamSliders = document.querySelectorAll('.team-quad__slider');
        teamSliders.forEach( (slider, index) => {
            let swiper = new Swiper(`.${slider.getAttribute('class')}` ,{
                loop: true,
                speed: 700,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true,
                    dynamicMainBullets: 1, 
                    type: 'bullets',
                    clickable: true,
                    renderBullet: function (index, className) {
                        let slideNumber = (index + 1) < 10 ? `0${index + 1}` : `${index + 1}`;
                        return `<span class="${className}"><span class="bullet-number">${slideNumber}</span></span>`;
                    }
                  }
            });
        })

        if( document.querySelectorAll('.quad-slider__names') ) {
            const namesSlider = document.querySelectorAll('.quad-slider__names');
            namesSlider.forEach( (slider, index) => {
                let swiper = new Swiper(slider ,{
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    breakpoints: {
                        600: {
                            slidesPerView: 4,
                        }
                    }
                });
            });
        }

    }


    if(document.querySelector('.room-images-slider')){
        let swiper = new Swiper('.room-images-slider', defaulsettings)
    }

    if(document.querySelector('.swiper-internal-room'))  {
        let swiper = new Swiper('.swiper-internal-room', {
            speed: 1000,
            loop: true,
            grabCursor: true,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: ".swiper-pagination",
                type: 'bullets',
                dynamicBullets: true,
                dynamicMainBullets: 1,   
            },
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev'
            },
            breakpoints: {
                "480": {
                    slidesPerView: "1",
                },
                "900": {
                    slidesPerView: "1.2",
                },
            }
        })
    }  

    if(document.querySelector('.gallery-mobile-slider')){
        let swiper= new Swiper('.gallery-mobile-slider', defaulsettings)
    }
});